import styled from 'styled-components';

export const FullWidthDiv = styled.div`
  width: 100%;
`;

export const WordWithoutBreak = styled.span`
  word-break: keep-all;
`;
